import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecomendedPaymentOptionComponent } from './recomended-payment-option.component';
import { PaymentSipUpiModule } from '../payment-sip-upi/payment-sip-upi.module';
import { PaymentSipButtonModule } from '../payment-sip-button/payment-sip-button.module';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [
    RecomendedPaymentOptionComponent
  ],
  exports: [
    RecomendedPaymentOptionComponent
  ],
  imports: [
    CommonModule,
    PaymentSipUpiModule,
    PaymentSipButtonModule,
    MatButtonModule
  ]
})
export class RecomendedPaymentOptionModule { }
